import PropTypes from 'prop-types'
import {Box, Text, Button, Link} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import {formatNumber} from '../../../utils/formatter'

const getConversionText = ([first, second], t) => {
  if (second === undefined) {
    return t('payments:RewardConfirmation.singleRedemption', {
      amount: formatNumber(first.amount),
      partnerKey: first.key,
    })
  }

  if (first.amount === second.amount) {
    return t('payments:RewardConfirmation.multipleRedemptionMatching', {
      amount: formatNumber(first.amount),
      partnerOneKey: first.key,
      partnerTwoKey: second.key,
    })
  }

  return t('payments:RewardConfirmation.multipleRedemption', {
    amountOne: formatNumber(first.amount),
    amountTwo: formatNumber(second.amount),
    partnerOneKey: first.key,
    partnerTwoKey: second.key,
  })
}

const PaymentSuccess = ({coins, redemptionOptions}) => {
  const {t} = useTranslation('payments')

  return (
    <Box mt="lg">
      <Text fontSize="lg" mb="sm">
        Thanks for your payment.
      </Text>
      {coins > 0 ? (
        <Box>
          <Box
            display="flex"
            justifyContent="space-between"
            borderTop="1px"
            borderColor="mld.neutral.500"
            pt="sm"
            pb="xs"
          >
            <Text>{t('RewardConfirmation.title')}</Text>
            <Text textStyle="body-copy-medium">
              {t('RewardConfirmation.coins', {coins: formatNumber(coins)})}
            </Text>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            backgroundColor="mld.neutral.200"
            borderRadius="sm"
            p="xs"
            justifyContent="space-between"
          >
            <Box>
              {redemptionOptions.length > 0 && (
                <Text>{getConversionText(redemptionOptions, t)}</Text>
              )}
            </Box>
            <Button
              as={Link}
              variant="primary"
              colorScheme="primary"
              px="md"
              href={t('RewardConfirmation.buttons.claimNow.url')}
            >
              {t('RewardConfirmation.buttons.claimNow.text')}
            </Button>
          </Box>
        </Box>
      ) : (
        <Text
          as="a"
          href="#"
          _hover={{textDecoration: 'underline'}}
          onClick={(e) => {
            e.preventDefault()
            window.close()
          }}
        >
          You may now close this window
        </Text>
      )}
    </Box>
  )
}

PaymentSuccess.propTypes = {
  coins: PropTypes.number,
  redemptionOptions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
    }),
  ),
}

PaymentSuccess.defaultProps = {
  coins: 0,
  redemptionOptions: [],
}

export default PaymentSuccess
